import styled from "styled-components";

export const Container = styled.div`
    align-items: center;
    background: black;
    color: white;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-around;
    text-transform: uppercase;
    width: 100%;
    & > h1{
        font-size: 20px;   
    }
`;

export const Clock = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    & .part{
        flex: 1;
        text-align: center;
    }
    & .part h1{
        font-size: 150px;
        font-weight: 200;
        line-clamp: 1.48;
        margin: 0;
    }
    @media (max-width:1080px){
    & .part h1{
        font-size: 100px;
        }
    }

    @media (max-width:760px){
        & .part h1{
            font-size: 50px;
        }
    }
`;